<p-dropdown
    [inputId]="inputId || undefined"
    [options]="impressoras"
    [(ngModel)]="value"
    optionLabel="nome"
    optionValue="id"
    [showClear]="showClear"
    [loading]="loading"
    [appendTo]="appendTo"
    scrollHeight="280px"
    styleClass="w-full"
    (onChange)="onSelect($event.value)"
    (onBlur)="onTouched()"
    [placeholder]="placeholder || ('selecionar' | translate)">

    <ng-template let-impressora pTemplate="item">
        <div class="flex align-items-center">
            <i class="pi pi-print mr-2"></i>
            <span>{{ impressora.nome }}</span>
        </div>
    </ng-template>

    <ng-template pTemplate="empty">
        <div class="p-2 text-center text-500">{{ 'nenhum_registro_encontrado' | translate }}</div>
    </ng-template>

    <!-- "Adicionar" vive no FOOTER, nao como item da lista: assim ele nao pode virar valor do
         ngModel (era o defeito do campo de pedido, que gravava a String 'adicionar'). -->
    <ng-template pTemplate="footer">
        <div *ngIf="showAddButton" class="impressora-add-item" role="button" tabindex="0"
            (mousedown)="onAddNew($event)">
            <div class="impressora-add-icon">
                <i class="pi pi-plus"></i>
            </div>
            <span class="impressora-add-label">{{ 'Adicionar' | translate }}</span>
        </div>
    </ng-template>
</p-dropdown>

<!-- Dialog de nova impressora -->
<app-impressora-adicionar-dialog
    [(visible)]="dialogVisible"
    (impressoraCriada)="onImpressoraCriada($event)">
</app-impressora-adicionar-dialog>
